'use strict';

/* global $ */

/**
 *  Ссылка Вверх
 */
function TopLink(options){
    var opt = $.extend({
        selector: '.js-top-link',
        offset: 100,
        duration: 600
    }, options);

    var $link = $(opt.selector),
        $body = $(/webkit/.test(navigator.userAgent) ? document.body : document.documentElement);

    $link.on('click', function(e) {
        e.preventDefault();

        $body.animate({ scrollTop: 0 }, { duration: opt.duration });
    });

    $(window).on('scroll', function() {
        if ($body.prop('scrollTop') > opt.offset) {
            $link.show();
        } else {
            $link.hide();
        }
    });

    $(document).click(function(event) { 
      let $target = $(event.target);
      
      if(!$target.closest('.js-product-buy').length) {
        $('.js-product-bask').remove();
      }
    });
}

export {
    TopLink
};
